<!-- 
Line chart.

Unlike most of our components you must call the "display" method to trigger displaying the chart.
Call display inside a $nextTick - see ActivityWidget for an example.
-->
<script>
import _ from "underscore";
import { Line } from "vue-chartjs";
import { DefaultColors } from "@/components/common/chart/helper.js";
import { deepCopy } from "@/store/helpers";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    chartOptions: {
      type: Object,
      default: null
    }
  },
  methods: {
    display() {
      const data = deepCopy(this.chartData);
      _.each(data.datasets, (d, index) => {
        d.borderColor = d.borderColor || (index < DefaultColors.length ? DefaultColors[index] : null);
        d.type = "line";
        d.fill = d.fill || false;
        d.borderWidth = 2;
        d.pointRadius = d.fill ? 2 : 4;
        d.pointHoverRadius = d.pointRadius + 1;
        d.pointHitRadius = 10;
        d.pointBorderColor = d.borderColor;
        d.pointBackgroundColor = d.borderColor;
        d.backgroundColor = d.backgroundColor || d.borderColor;
      });
      var options = this.chartOptions || {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: "bottom"
        }
      };
      this.renderChart(data, options);
    }
  }
};
</script>
